import Section from 'Components/ContractGenerator/layouts/Section';
import Constants from 'Components/ContractGenerator/shared/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

import SelectedProduct from '../../../layouts/SelectedProduct';
import styles from './Selection.module.scss';

const Selection = () => {
	const { t } = useTranslation(['contractGenerator', 'translation']);
	const dispatch = useDispatch();

	const { ACCOMMODATION_TYPES } = useSelector(contractGeneratorSelectors.getConstants);
	const { selectedRooms, selectedContractTermInMonths, selectedAccommodationType } = useSelector(
		contractGeneratorSelectors.getDataToSubmit
	);
	const blockedFields = useSelector(contractGeneratorSelectors.getBlockedFields);
	const buttonIsDisabled = blockedFields?.selectedRooms && blockedFields?.selectedContractTermInMonths && blockedFields?.selectedProduct;
	const contractTermText =
		selectedContractTermInMonths !== 0
			? `${selectedContractTermInMonths} ${t('pages.step2.selection.months')}`
			: t('pages.step2.selection.monthlyCancelable');

	return (
		<Section headline={t('pages.step2.selection.headline')} firstElementOfStep>
			<FlexBox className={styles.wrap} justifyContent='center'>
				<FlexBox alignItems='center' className={styles.item}>
					<FlexBox alignItems='center' className={styles.iconCircle} justifyContent='center'>
						<Icon color='bright' icon='fa-bed' iconWeight='fal' size='xl' />
					</FlexBox>
					<Spacer width='m' />
					<strong>
						{selectedRooms}{' '}
						{t(
							`translation:${ACCOMMODATION_TYPES[selectedAccommodationType].UNIT_TRANSLATION_PATH}.${
								selectedRooms === 1 ? 'singular' : 'plural'
							}`
						)}
					</strong>
				</FlexBox>
				<Spacer width='xl' />
				<FlexBox alignItems='center' className={styles.item}>
					<FlexBox alignItems='center' className={styles.iconCircle} justifyContent='center'>
						<Icon color='bright' icon='fa-clock' iconWeight='fal' size='xl' />
					</FlexBox>
					<Spacer width='m' />
					<strong>{contractTermText}</strong>
				</FlexBox>
				{!buttonIsDisabled && (
					<>
						<Spacer width='xxl' />
						<Spacer width='xl' />
						<Button
							className={styles.item}
							type='dark'
							onClick={() =>
								dispatch(
									contractGeneratorOperations.setActiveStep(
										Constants.STEPS.STEP1,
										'viato-contract-generator-contract-settings',
										true
									)
								)
							}
						>
							{t('app.userActions.change')}
						</Button>
					</>
				)}
			</FlexBox>
			<Spacer height='xl' />

			<SelectedProduct />
		</Section>
	);
};

export default Selection;
